import React, { useState, useEffect } from "react";
import { useContext } from "react";
import WithdrawalHistoryAPI from "../../../../../api/withdrawal_history";
import { loadingContext } from "../../../../Contexts/Loading";
import Paginator from "../../../Paginator/Paginator";
import DataWrapper from "./dataWrapper/DataWrapper";

const WithdrawTransactions = ({ type }) => {
  const [withdrawalHistory, setWithdrawalHistory] = useState([]);
  const { loadingData, setLoadingData } = useContext(loadingContext);
  const [currentPage, handlePage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [lastPage, setlastPage] = useState(false);

  useEffect(() => {
    setLoadingData(true);
    setlastPage(true);

    WithdrawalHistoryAPI.get_withdrawal_histories_data(currentPage).then(
      (response) => {
        setWithdrawalHistory(response.data.withdrawal_histories_data);
        handlePage(response.data.current_page);
        setTotalPages(response.data.total_pages);
        setlastPage(response.data.last_page);
        setLoadingData(false);
      }
    );
  }, [currentPage]);
  return (
    <>
      <DataWrapper
        transactions={withdrawalHistory}
        loadingData={loadingData}
        type={type}
      />
      <div
        style={{
          position: "fixed",
          bottom: "21px",
          zIndex: 1,
          boxSizing: "border-box",
          width: "94%",
        }}
        className="pagination-position-assign absolute width-50"
      >
        <Paginator
          currentPage={currentPage}
          totalPages={totalPages}
          lastPage={lastPage}
          handlePage={handlePage}
        />
      </div>
    </>
  );
};

export default WithdrawTransactions;
